import React, { useContext, useEffect, useState } from "react";
import { useCart } from "../CartContext";
import { ContextProvider } from "../../../../App";
import AddToCartComp from "../AddToCartComp";
import useWishListData from "../../../hooks/useWishListData";
import { RiHeart3Fill, RiHeartLine } from "react-icons/ri";
import { CiDeliveryTruck } from "react-icons/ci";
import { useLocation, useNavigate } from "react-router";
import { Discountprice } from "../../../utils/constant";
import ProductDesc from "./ProductDesc";

const ProductDetails = ({ menuData, ProductDescriptions }) => {
  // console.log("menuData", menuData);
  const navigate = useNavigate();
  const location = useLocation();
  const [productCardQty, setProductCardQty] = useState(1);
  const {
    name,
    id,
    weight,
    productDetails,
    actual_price,
    sub_category,
    category,
    offer_price,
    priceOptions,
  } = menuData;

  const [selectedPiece, setSelectedPiece] = useState(priceOptions[0]);

  const removeNameSpaces = name?.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase();
  const removeSubCatSpaces = sub_category
    ?.replace(/[^a-zA-Z0-9]/g, "-")
    .toLowerCase();
  const removeCategorySpaces = category?.catKey
    ?.replace(/[^a-zA-Z0-9]/g, "-")
    .toLowerCase();

  const {
    manufacturerTitle,
    manufacturerName,
    manufacturerFrom,
    returnPolicyTitle,
    returnPolicy,
    specialityDesc1,
    specialityTitle,
    specialityDesc2,
  } = productDetails;
  const {
    newCart,
    addToCart,
    updateQuantity,
    handleRemoveWishlist,
    handleCreateWishlist,
    buyItem,
    setBuyItem,
  } = useCart();

  const [showQtyBtn, setShowQtyBtn] = useState(false);
  const {
    setOpenDrawer,
    showGridType,
    token,
    setShowLoader,
    selectedWishList,
    setSelectedWishlist,
  } = useContext(ContextProvider);
  const { wishListData, setWishListData } = useWishListData();

  useEffect(() => {
    const cartItem = newCart?.some((item) => item.id === menuData.id);

    const cartItem1 = newCart?.find((item) => item.id === menuData.id);

    if (cartItem?.quantity ?? cartItem?.quantity >= 1) {
      setShowQtyBtn(true);
    } else {
      setShowQtyBtn(false);
    }
  }, [newCart, menuData.id]);

  const selectedWishListData = wishListData?.some(
    (data) => data?.id === menuData?.id
  );

  const handleBuyItem = (item) => {
    // console.log(item);

    if (!token) {
      navigate("/login", { state: { from: location?.pathname } });
    } else if (item) {
      setBuyItem([{ product: { ...item, quantity: productCardQty } }]);

      navigate("/checkout");
    }
  };

  const handleWishList = (wishlistId) => {
    if (!token) {
      setShowLoader(true);
      navigate("/wishlist");
    }

    const isWishListed = wishListData.some((item) => item?.id === wishlistId);

    if (isWishListed) {
      setWishListData((prev) => prev.filter((item) => item.id !== wishlistId));

      handleRemoveWishlist(wishlistId).catch(() => {
        setWishListData((prev) => [...prev, { id: wishlistId }]);
      });
    } else {
      setWishListData((prev) => [...prev, { id: wishlistId }]);

      handleCreateWishlist(wishlistId).catch(() => {
        setWishListData((prev) =>
          prev.filter((item) => item.id !== wishlistId)
        );
      });
    }
  };

  const HandleChangeWeight = (option) => {
    setSelectedPiece(option);
    navigate(
      `/${removeCategorySpaces}/${removeSubCatSpaces}/${id}/${removeNameSpaces}/variant/${selectedPiece?._id}`
    );

    // navigate(
    //   `/${removeCategorySpaces}/${removeSubCatSpaces}/${id}/${removeNameSpaces}`
    // );
  };

  const handleAddToCart = () => {
    addToCart(menuData, setOpenDrawer);
    setOpenDrawer(true);
  };

  return (
    <div className="sm:w-1/2 w-full md:px-5">
      <div className=" w-full  flex flex-col  md:gap-3 gap-1">
        <div className="">
          <h2 className="md:text-3xl text-xl font-semibold">
            {name} <span className="text-lg">( {selectedPiece?.weight} )</span>
          </h2>
          {/* <h2 className="md:text-3xl text-xl font-semibold">
            {name} <span className="text-lg">( {weight} )</span>
          </h2> */}

          {/* Old Price New Price Discount Off Section */}

          <Discountprice
            actual_price={actual_price}
            offer_price={offer_price}
            priceOptions={selectedPiece}
            styling={"md:text-2xl md:py-3 py-1 font-medium flex items-center "}
          />
        </div>
        <div className="flex flex-col md:gap-3 gap-1 md:text-base text-sm">
          <div className="text-md">
            <h2 className="font-semibold">{manufacturerTitle}</h2>
            <p className="text-mediumGray uppercase">{manufacturerName}</p>
            <p className="text-sm text-mediumGray">{manufacturerFrom}</p>
          </div>

          <div className="text-md">
            <h2 className="font-semibold">{returnPolicyTitle}</h2>
            <p className="text-mediumGray">{returnPolicy}</p>
          </div>
          {specialityDesc1 && (
            <div className="text-md">
              <h2 className="font-semibold">{specialityTitle}</h2>
              <p className="text-mediumGray py-1">{specialityDesc1}</p>
              <p className="text-mediumGray">{specialityDesc2}</p>
            </div>
          )}

          {/* Sizes Section */}

          {priceOptions?.length > 1 && (
            <div className="flex items-center gap-2">
              <h2 className="text-lg">Size:</h2>
              <div className="flex gap-3">
                {priceOptions?.map((option) => {
                  return (
                    <button
                      key={option._id}
                      onClick={() => HandleChangeWeight(option)}
                      className={`border px-2 py-1 rounded text-sm ${
                        selectedPiece?.weight === option?.weight
                          ? "border-main"
                          : "border-lightGray"
                      }`}
                    >
                      {option?.weight}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* <div className="text-md">
      <h2 className="font-semibold">{expireTitle}</h2>
      <p className="text-mediumGray">{expire}</p>
    </div> */}
        </div>

        {/* AddtoCart and Buy now Buttons */}

        <div className="md:w-96 w-full flex flex-col gap-2">
          <div className="flex gap-1">
            {/*********  Increase Decrease Button  ************/}

            <div className="w-20 md:p-3 p-2 flex items-center justify-around border border-mediumGray rounded">
              <button
                className={`${
                  productCardQty === 1
                    ? "disabled opacity-50 cursor-not-allowed"
                    : ""
                }`}
                onClick={() => {
                  setProductCardQty(productCardQty - 1);
                }}
                disabled={productCardQty === 1}
              >
                -
              </button>
              <p>{productCardQty}</p>
              <button
                onClick={() => {
                  setProductCardQty(productCardQty + 1);
                }}
              >
                +
              </button>
            </div>

            {/*********    Addtocart Button    ************/}
            <button
              onClick={() => {
                addToCart(menuData, selectedPiece, productCardQty);
                // addToCart(menuData, setOpenDrawer, productCardQty);
                // setShowQtyBtn(true);
                // console.log({ ...menuData, priceOptions: { ...selectedPiece } });
              }}
              className="border border-main rounded bg-main text-white font-medium w-full sm:w-60 md:p-3 p-2"
            >
              Add to cart
            </button>

            {/*********    WIshlist Button    ************/}

            <button
              onClick={() => {
                handleWishList(menuData?.id);
                // window.location.reload();
              }}
              className={`border w-fit md:p-3 p-2 rounded ${
                selectedWishListData
                  ? "border-error text-error"
                  : "border-lightGray"
              }`}
            >
              {selectedWishListData ? (
                <div className="flex">
                  <RiHeart3Fill size={20} />
                </div>
              ) : (
                <div className="flex items-center justify-around">
                  <RiHeartLine size={20} />
                </div>
              )}
            </button>
          </div>

          {/**********    Buy now Button    ***********/}
          <button
            onClick={() => handleBuyItem(menuData)}
            className="styleButton w-full md:p-3 p-2"
          >
            Buy now
          </button>
        </div>
        <div className="flex items-center gap-2">
          <CiDeliveryTruck size={25} className="animate-bounce" />
          <p className="text-sm font-semibold">
            Why pay for shipping? Get it free on orders above ₹ 1499
          </p>
        </div>
      </div>
      {ProductDescriptions?.product_description?.length >= 1 && (
        <ProductDesc ProductDescriptions={ProductDescriptions} />
      )}{" "}
    </div>
  );
};

export default React.memo(ProductDetails);
